import { proxy, subscribe } from "valtio";

export const StorageKey = {
  STATE: "coachPlatformState",
  PROFILE: "coachPlatformProfileState",
  DATA_FETCH: "coachPlatformDataFetchState",
};

export const state = proxy(
  typeof window !== "undefined" && localStorage.getItem(StorageKey.STATE)
    ? JSON.parse(localStorage.getItem(StorageKey.STATE)!)
    : {
        role: "coach",
        sidebarExpanded: false,
      }
);

subscribe(state, () => {
  if (typeof window !== "undefined")
    localStorage.setItem(StorageKey.STATE, JSON.stringify(state));
});



export const profileState = proxy(
  typeof window !== "undefined" && localStorage.getItem(StorageKey.PROFILE)
    ? JSON.parse(localStorage.getItem(StorageKey.PROFILE)!)
    : {
        profile: null,
      }
);

subscribe(profileState, () => {
  if (typeof window !== "undefined")
    localStorage.setItem(StorageKey.PROFILE, JSON.stringify(profileState));
});

export const dataFetchState = proxy(
  typeof window !== "undefined" && localStorage.getItem(StorageKey.DATA_FETCH)
    ? JSON.parse(localStorage.getItem(StorageKey.DATA_FETCH)!)
    : {
        packages: [],
        coachForms: [],
      }
);

subscribe(dataFetchState, () => {
  if (typeof window !== "undefined")
    localStorage.setItem(StorageKey.DATA_FETCH, JSON.stringify(dataFetchState));
});
